import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarHeart, X } from 'lucide-react';

// Story 43.6 (RC-013, AC1): aviso pós-release do fix de datas de import — texto fiel
// ao template T1 (artefatos pedro-valerio §PASS 3), zero jargão (teste da filha).
// Sem registro de "já importou alguma vez" disponível no cliente, a mitigação aceita
// pela story é: exibir uma única vez para todas, dispensável (dismiss persiste).

export const DATE_FIX_NOTICE_KEY = 'valiosas.dateFixNotice.dismissed.v1';

export function DateFixNoticeBanner() {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DATE_FIX_NOTICE_KEY) === '1',
  );

  if (dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(DATE_FIX_NOTICE_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="flex flex-wrap items-start gap-3 border-b border-sky-200 bg-sky-50 px-4 py-2 text-so-14 text-sky-950 lg:px-8">
      <CalendarHeart className="mt-3 size-4 shrink-0 text-sky-700" />
      <details className="min-w-0 flex-1">
        <summary className="min-h-11 cursor-pointer rounded-so-sm py-2 font-bold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-800">
          Confira as datas importadas de planilha
        </summary>
        <p className="mt-1 text-sky-800">
          Encontramos um problema (já corrigido) que podia trocar dia e mês do aniversário de
          clientes importadas por planilha — ex.: 08/01 virava 01/08. Quem nasceu do dia 13 em
          diante pode ter ficado sem data.
        </p>
        <p className="mt-1 text-sky-800">
          <strong>Como corrigir:</strong> importe a MESMA planilha de novo em Pacientes →
          Importar, escolhendo <strong>&quot;Atualizar existentes&quot;</strong>. O sistema
          conserta as datas automaticamente e não duplica ninguém.
        </p>
        <div className="mt-2">
          <button
            type="button"
            onClick={() => {
              dismiss();
              navigate('/pacientes?import=1');
            }}
            className="rounded-so-sm bg-sky-900 min-h-11 px-3 py-2 text-so-14 font-bold text-white hover:bg-sky-800"
          >
            Importar agora
          </button>
        </div>
      </details>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Recolher aviso"
        className="inline-flex min-h-11 shrink-0 items-center gap-1 rounded-so-sm px-2 text-so-12 font-bold text-sky-700 hover:bg-sky-100 focus-visible:ring-2 focus-visible:ring-sky-800"
      >
        <X className="size-4" />
        Recolher
      </button>
    </div>
  );
}
